import { Box, Typography } from "@mui/material";
import TextIntegrationStyle from "../../TextIntegrationStyle";

const JamfAPIKeyDetailsView = ({ entityData }) => {
  return (
    <Box display={"flex"} flexDirection={"column"} gap={2}>
      {entityData?.display_name && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box
            display={"flex"}
            flexDirection={"row"}
            alignItems={"center"}
            gap={1}
          >
            <Typography variant={"subtitle2"}>Name</Typography>
          </Box>
          <Box ml={2} display={"flex"}>
            <TextIntegrationStyle
              title={""}
              value={entityData?.display_name}
            ></TextIntegrationStyle>
          </Box>
        </Box>
      )}
      {entityData?.jamf_api_key_data?.permissions && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box
            display={"flex"}
            flexDirection={"row"}
            alignItems={"center"}
            gap={1}
          >
            <Typography variant={"subtitle2"}>Permissions</Typography>
          </Box>
          <Box display={"flex"} flexDirection={"column"} gap={2} ml={2}>
            {Object.entries(entityData.jamf_api_key_data.permissions).map(
              ([roleName, permissions]) => (
                <Box
                  key={roleName}
                  display={"flex"}
                  flexDirection={"column"}
                  gap={0.5}
                >
                  <Box
                    display={"flex"}
                    flexDirection={"column"}
                    gap={0.5}
                    maxHeight={250}
                    overflow="auto"
                  >
                    {permissions.sort().map((permission, index) => (
                      <TextIntegrationStyle
                        key={index}
                        title={""}
                        value={permission}
                      />
                    ))}
                  </Box>
                </Box>
              )
            )}
          </Box>
        </Box>
      )}
      {entityData?.jamf_api_key_data?.enabled && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box
            display={"flex"}
            flexDirection={"row"}
            alignItems={"center"}
            gap={1}
          >
            <Typography variant={"subtitle2"}>API Key</Typography>
          </Box>
          <Box ml={2} display={"flex"}>
            <TextIntegrationStyle
              title={""}
              value={"Enabled"}
            ></TextIntegrationStyle>
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default JamfAPIKeyDetailsView;
